import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 6h5l7 10h6","key":"svg-0"}],["path",{"d":"M18 19l3 -3l-3 -3","key":"svg-1"}]]

const IconTrendingDown2 = createReactComponent('outline', 'trending-down-2', 'TrendingDown2', __iconNode);

export default IconTrendingDown2;